export enum ShiftDigitalEnvironment {
  STAGING = 'staging',
  PRODUCTION = 'production',
}
